module.exports = __webpack_public_path__ + "static/media/22.33265f17.jpg";